import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../common/CmnContext';
import { PracticeReseveContext } from '../PracticeReseveContext';
import Loading from '../../../common/loading/Loading';
import PracticeReserveModeTab from './modeTab/PracticeReserveModeTab';
import PracticeReserveSelectInstructor from './selectInstructor/PracticeReserveSelectInstructor';
import PracticeReserveTime from './time/PracticeReserveTime';
import PracticeReserveDatetime from './datetime/PracticeReserveDatetime';
import PracticeReserveSituation from './situation/PracticeReserveSituation';
import PracticeReserveFreeTalkTopick from './freeTalkTopick/PracticeReserveFreeTalkTopick';
import PracticeReserveRequest from './request/PracticeReserveRequest';
import PracticeReserveSubmit from './submit/PracticeReserveSubmit';
import PracticeReserveTicketLess from './ticketLess/PracticeReserveTicketLess';
import PracticeReserveAccessAlert from './accessAlert/PracticeReserveAccessAlert';

import { PRACTICE_RESERVE_MODE } from '../../../../models/practice/reserve/mode/PracticeReserveMode';


function PracticeReserveForm() {

  const { isPc } = useContext(cmnContext);
  const {
    lessonTermMinute, formRef,
    canSelectReserveMode, reserveMode,
    isLoading, isLesson,
    lsnMin, trialCount, isTicketLess,
    selectedScheduleId, submitScheduleId, selectedSituation,
  } = useContext(PracticeReseveContext);

  // (予約の可否)無料回数/チケットの不足
  const [canReserve, setCanReserve] = useState(false);

  // 日時から選ぶ：講師 → 時間 → 日程 の並びを 時間 → 日程 → 講師 にする
  const isDatetimeMode = reserveMode === PRACTICE_RESERVE_MODE.DATETIME;

  // 予約エラーで画面が読み込み直されても同じ表示で開くよう、sub_course・モードを URL で引き継ぐ
  const actionParams = new URLSearchParams();
  if(canSelectReserveMode) actionParams.set('sub_course', 'all');
  if(isDatetimeMode) actionParams.set('reserve_mode', PRACTICE_RESERVE_MODE.DATETIME);
  const actionQuery = actionParams.toString();


  // (予約の可否)無料回数/チケットの不足
  useEffect(() => {
    setCanReserve(
      !isTicketLess || //チケット数
      trialCount >= lsnMin / lessonTermMinute //無料回数
    );
  }, [lsnMin, trialCount, isTicketLess])


  return (
    <form
      ref={formRef}
      action={actionQuery ? `/practice?${actionQuery}` : '/practice'}
      method="post"
    >
      <input type="hidden" name="mode" value="1"/>
      <input type="hidden" name="chat_type" value="1"/>
      {/* 送る枠：日時から選ぶでは選んだ講師の枠（selectedScheduleId は日時を表す） */}
      <input type='hidden' name='sche_id' value={submitScheduleId} />
      <input type='hidden' name='situation' value={selectedSituation} />

      {/* モード切り替え（講師から選ぶ／日時から選ぶ）。sub_course=all のときだけ出す */}
      {canSelectReserveMode && <PracticeReserveModeTab />}

      {/* セッションする外国人講師（講師から選ぶ） */}
      {!isDatetimeMode && <PracticeReserveSelectInstructor />}
      {/* 時間選択 */}
      <PracticeReserveTime />

      <>
        {isLesson ?
          <>
            {canReserve ?
              <>
                {isLoading ?
                  <Loading width={isPc? '5%':'10%'} />
                :
                <>
                  {/* 日程選択 */}
                  <PracticeReserveDatetime />
                  {/* セッションする外国人講師（日時から選ぶ：日程を選ぶまでは出さない） */}
                  {(isDatetimeMode && selectedScheduleId) && <PracticeReserveSelectInstructor />}
                </>
                }

                {/* 実践したい内容 */}
                <PracticeReserveSituation />

                {/* フリートーク：トピック */}
                <PracticeReserveFreeTalkTopick />

                {/* 講師へのコメント */}
                <PracticeReserveRequest />

                {/* 予約ボタン */}
                <PracticeReserveSubmit />
              </>
            :
              <>
                {/* 無料回数/チケット不足 */}
                <PracticeReserveTicketLess />
              </>
            }
          </>
        :
          <>
            {/* アクセス集中 */}
            <PracticeReserveAccessAlert />
          </>
        }
      </>

    </form>
  );
}
  
export default PracticeReserveForm;